module.exports = __webpack_public_path__ + "img/user.c7c4037d.png";